import * as React from 'react';
import cx from 'classnames';
import { withNativeProps } from '@/utils/with-native-props';
import './cn-select-tag.scss';
/**
 * @category 组件
 * @description 选择用标签，为 CnSelector 的底层组件一般无需单独调用
 */
export const CnSelectTag = (props) => {
    const { type, checked, disabled, children, onClick } = props;
    const classes = cx({
        'cn-ui-m-select-tag': true,
        [`cn-ui-m-select-tag-type-${type}`]: !!type,
        'cn-ui-m-select-tag-checked': !!checked,
        'cn-ui-m-select-tag-disabled': !!disabled,
    });
    return withNativeProps(props, React.createElement("div", { onClick: onClick, className: classes }, children));
};
CnSelectTag.displayName = 'CnSelectTag';
CnSelectTag.defaultProps = {
    type: 'default',
    checked: false,
    disabled: false,
};
